import React from 'react';
import NavBarItem from './NavBarItem';
import {Message} from '@aperza/ui';
import AppService from '../service/AppService';
import type AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class NavBarForNews extends React.Component {

  render() {

    return (
      <div className="strip navbar-news" style={{justifyContent: 'space-between'}}>
        <div className="strip">
          <NavBarItem title={<Message messageId="navBarNews.article" />}
                      url={`https://news${appConfig.baseDomain}/global_cat/gn_essay/`}>
          </NavBarItem>
          <NavBarItem title={<Message messageId="navBarNews.entertainment" />}
                      url={`https://news${appConfig.baseDomain}/global_cat/gn_entertainment/`}
          />
          <NavBarItem title={<Message messageId="navBarNews.glossary" />}
                      url={`https://news${appConfig.baseDomain}/global_cat/gn_knowledge/`} />
          <NavBarItem title={<Message messageId="navBarNews.event" />}
                      url={`https://news${appConfig.baseDomain}/global_cat/gn_events/`} />
          <NavBarItem title={<Message messageId="navBarNews.news" />}
                      url={`https://news${appConfig.baseDomain}/global_cat/gn_latest/`} />
        </div>
      </div>
    )
  }

}
